<h1 mat-dialog-title>Are you sure you want to delete this user?</h1>
<div mat-dialog-content>
  the chat and contact will be completely removed

  <div class="actions">
    <button mat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
      Delete user
    </button>
    <button mat-button [mat-dialog-close]="false" color="primary">Close</button>
  </div>
</div>
